/** @format */

import { UIRow, UICol, UIText, UIInput } from "@rstore-react-packages/template-ui";
import { Button, Form } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { actionPartnerDeleteRequest } from "../../../../redux-modules/actions/actionsPartner";
import { TPartnerForSelect } from "../../../../redux-modules/declarations/maps/partner";
import { useLanguage } from "../../../../redux-modules/hooks/useLanguage";
import StyledModal from "../../../ui/Modal";

/** @format */
interface Props {
  visible: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  partner: TPartnerForSelect;
}
const ModalDeletePartner = ({
  visible = false,
  handleCancel,
  handleOk,
  partner,
}: Props): JSX.Element => {
  const l = useLanguage();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [canDelete, setCanDelete] = useState(false);
  const [typedValue, setTypedValue] = useState("");

  const handleFinish = (form): void => {
    dispatch(actionPartnerDeleteRequest(partner.key));
    console.log("del");
    //@ts-ignore
    handleOk && handleOk();
  };

  const handleReturn = (): void => {
    handleCancel && handleCancel();
  };

  useEffect(() => {
    if (typedValue === "delete partner") setCanDelete(true);
    else setCanDelete(false);
  }, [typedValue]);

  return (
    <StyledModal
      title={l("delete")}
      visible={visible}
      //@ts-ignore
      canDelete={canDelete}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleReturn}>
          Return
        </Button>,
        <Button key="submit" disabled={!canDelete} onClick={(): void => form.submit()}>
          Submit
        </Button>,
      ]}
    >
      <UIRow>
        <UICol xs={24}>
          <Form form={form} name="edit-partner-status" layout="inline" onFinish={handleFinish}>
            <UIText>{"You are deleting a partner."}</UIText>
          </Form>
        </UICol>
      </UIRow>
      <UIRow style={{ marginTop: "10px" }}>
        <UIText>To confirm the operation type "delete partner":</UIText>
        <UIInput onChange={(e): void => setTypedValue(e.target.value)} />
      </UIRow>
    </StyledModal>
  );
};

export default ModalDeletePartner;
